module.exports = __webpack_public_path__ + "img/product-1-thumb-1.7688e323.jpg";